(function () {
  'use strict';
  function setup(form) {
    if (form.dataset.cccpReady === 'yes') return;
    var steps = Array.from(form.querySelectorAll('[data-cccp-step]'));
    var back = form.querySelector('[data-cccp-back]');
    var next = form.querySelector('[data-cccp-next]');
    var send = form.querySelector('[data-cccp-submit]');
    var stepLabel = form.querySelector('[data-cccp-step-label]');
    var stepName = form.querySelector('[data-cccp-step-name]');
    var progress = form.querySelector('[data-cccp-progress]');
    var fill = form.querySelector('[data-cccp-progress-fill]');
    var review = form.querySelector('[data-cccp-review]');
    var summary = form.querySelector('#cccp-inquiry-summary');
    var beverage = form.querySelector('[data-cccp-beverage]');
    var alcohol = form.querySelector('[data-cccp-alcohol]');
    var campaign = form.querySelector('[data-cccp-campaign]');
    var announcement = form.querySelector('[data-cccp-announcement]');
    if (steps.length !== 3 || !back || !next || !send || !stepLabel || !stepName || !progress || !fill || !review || !summary) return;
    var current = 0;
    var names = ['Your project', 'Production plans', 'Your details'];
    form.dataset.cccpReady = 'yes';
    form.classList.add('cccp-wizard--enhanced');
    form.noValidate = true;

    function conditional() {
      if (!beverage || !alcohol) return;
      var hide = beverage.value === 'Non-alcoholic beverage';
      alcohol.hidden = hide;
      var input = alcohol.querySelector('input');
      if (input) { input.disabled = hide; if (hide) input.value = ''; }
    }
    function rows() {
      var found = new Set();
      var omit = new Set(['contact[body]', 'contact[Inquiry category]', 'contact[Lead source]', 'contact[Inquiry form version]', 'contact[Campaign reference]', 'contact[Contact authorization]']);
      return Array.from(form.querySelectorAll('input[name^="contact["], select[name^="contact["], textarea[name^="contact["]')).map(function (el) {
        if (el.disabled || omit.has(el.name) || found.has(el.name) || (el.type === 'radio' && !el.checked) || (el.type === 'checkbox' && !el.checked) || !String(el.value).trim()) return null;
        found.add(el.name);
        return { key: el.name.slice(8, -1), value: String(el.value).trim() };
      }).filter(Boolean);
    }
    function makeReview() {
      review.replaceChildren();
      rows().forEach(function (item) {
        var pair = document.createElement('div');
        var dt = document.createElement('dt');
        var dd = document.createElement('dd');
        pair.className = 'cccp-review__row';
        dt.textContent = item.key;
        dd.textContent = item.value;
        pair.append(dt, dd);
        review.append(pair);
      });
    }
    function show(number, moveFocus) {
      current = Math.max(0, Math.min(steps.length - 1, number));
      steps.forEach(function (step, i) { step.hidden = i !== current; });
      back.hidden = current === 0;
      next.hidden = current === steps.length - 1;
      send.hidden = current !== steps.length - 1;
      stepLabel.textContent = 'Step ' + (current + 1) + ' of ' + steps.length;
      stepName.textContent = names[current];
      progress.setAttribute('aria-valuenow', String(current + 1));
      fill.style.width = (current + 1) / steps.length * 100 + '%';
      if (current === steps.length - 1) makeReview();
      if (announcement) announcement.textContent = stepLabel.textContent + ', ' + names[current];
      if (moveFocus) {
        var h = steps[current].querySelector('h3');
        if (h) { h.tabIndex = -1; h.focus({ preventScroll: true }); }
        form.scrollIntoView({ block: 'start', behavior: 'auto' });
      }
    }
    function valid(i) {
      var fields = steps[i].querySelectorAll('input,select,textarea');
      for (var j = 0; j < fields.length; j++) {
        if (fields[j].disabled) continue;
        if (!fields[j].checkValidity()) {
          show(i, false);
          fields[j].focus();
          fields[j].reportValidity();
          return false;
        }
      }
      return true;
    }
    if (beverage) beverage.addEventListener('change', conditional);
    conditional();
    if (campaign) {
      var params = new URLSearchParams(location.search);
      campaign.value = ['utm_source','utm_medium','utm_campaign'].map(function (key) {
        var v = (params.get(key) || '').slice(0, 80).replace(/[^\w. +@/-]/g, '');
        return v ? key + '=' + v : '';
      }).filter(Boolean).join('; ').slice(0, 250);
    }
    next.addEventListener('click', function () { if (valid(current)) show(current + 1, true); });
    back.addEventListener('click', function () { show(current - 1, true); });
    var errorBox = form.querySelector('[data-cccp-submit-error]');
    var secureToggle = form.querySelector('[data-cccp-crm-enabled]');
    var secureEndpoint = form.querySelector('[data-cccp-crm-endpoint]');
    var sitekeyField = form.querySelector('[data-cccp-sitekey]');
    var captcha = form.querySelector('[data-cccp-captcha]');
    var captchaWidget = form.querySelector('[data-cccp-captcha-widget]');
    var sitekey = sitekeyField ? sitekeyField.value.trim() : '';
    var secureRequested = Boolean(secureToggle && secureToggle.value === 'true');
    var secureMode = Boolean(secureRequested && secureEndpoint && secureEndpoint.value && sitekey && captcha && captchaWidget);
    var turnstileToken = '';
    var turnstileWidgetId = null;
    if (secureMode) {
      captcha.hidden = false;
      function initializeTurnstile() {
        if (!window.turnstile || typeof window.turnstile.render !== 'function') {
          showError('Security verification could not load. Please retry.');
          return;
        }
        if (turnstileWidgetId !== null) return;
        try {
          turnstileWidgetId = window.turnstile.render(captchaWidget, {
            sitekey: sitekey,
            action: 'copack_lead',
            callback: function (token) { turnstileToken = token; clearError(); },
            'expired-callback': function () { turnstileToken = ''; },
            'error-callback': function () { turnstileToken = ''; showError('Security verification is unavailable. Please try again.'); }
          });
        } catch (e) {
          showError('Security verification could not start. Please retry.');
        }
      }
      if (window.turnstile && typeof window.turnstile.render === 'function') {
        initializeTurnstile();
      } else {
        var challengeScript = document.createElement('script');
        challengeScript.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        challengeScript.async = true;
        challengeScript.onload = initializeTurnstile;
        challengeScript.onerror = function () { showError('Security verification could not load. Please retry.'); };
        document.head.appendChild(challengeScript);
      }
    }
    var requestKey = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : '';
    function getValue(name) {
      var input = form.elements.namedItem('contact[' + name + ']');
      return input && input.value ? String(input.value).trim() : '';
    }
    function showError(message) {
      if (errorBox) {
        errorBox.hidden = false;
        errorBox.textContent = message;
        errorBox.scrollIntoView({ block: 'nearest' });
      }
    }
    function clearError() {
      if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
    }
    function showSuccess(inquiryId) {
      var shell = form.closest('.cccp-form-shell');
      if (!shell) return;
      var container = document.createElement('div');
      container.className = 'cccp-wizard cccp-wizard__complete';
      container.setAttribute('role', 'status');
      var heading = document.createElement('h3');
      heading.textContent = 'Project inquiry received.';
      var copy = document.createElement('p');
      copy.textContent = 'Your project has been securely received by Cider Creek for review. We look forward to learning more about your project.';
      var reference = document.createElement('p');
      reference.className = 'cccp-wizard__reference';
      reference.textContent = 'Reference: ' + inquiryId;
      container.append(heading, copy, reference);
      shell.replaceChildren(container);
    }
    function projectData() {
      return {
        requestKey: requestKey,
        company: getValue('Company'),
        contactName: getValue('Contact name'),
        email: getValue('email'),
        phone: getValue('Phone'),
        companyWebsite: getValue('Company website'),
        location: getValue('Business location'),
        projectType: getValue('Project type'),
        beverageCategory: getValue('Beverage category'),
        projectStage: getValue('Project stage'),
        approximateAbv: getValue('Approximate ABV'),
        packaging: getValue('Packaging preference'),
        quantity: getValue('Estimated quantity'),
        quantityUnit: getValue('Quantity unit'),
        productionFrequency: getValue('Production frequency'),
        timeline: getValue('Desired timeline'),
        licensingStatus: getValue('Licensing status'),
        beverageNotes: getValue('Beverage notes'),
        productionNotes: getValue('Production notes'),
        projectNotes: getValue('Project notes'),
        campaign: getValue('Campaign reference'),
        contactAuthorized: Boolean(form.querySelector('input[name="contact[Contact authorization]"]:checked')),
        websiteConfirmation: form.querySelector('[data-cccp-honeypot]')?.value || ''
      };
    }
    form.addEventListener('submit', async function (event) {
      if (form.dataset.cccpSending === 'yes') { event.preventDefault(); return; }
      for (var i = 0; i < steps.length; i++) {
        if (!valid(i)) { event.preventDefault(); return; }
      }
      summary.value = ['CIDER CREEK — CO-PACKING INQUIRY'].concat(rows().map(function (x) { return x.key + ': ' + x.value; })).join('\n');
      if (secureRequested && !secureMode) {
        event.preventDefault();
        showError('Secure submissions are not fully configured. Please contact Cider Creek directly.');
        return;
      }
      if (!secureMode) {
        form.dataset.cccpSending = 'yes';
        send.disabled = true;
        send.textContent = 'Sending…';
        return;
      }

      event.preventDefault();
      clearError();
      if (!turnstileToken) {
        showError('Please complete the security check before sending your project.');
        return;
      }
      form.dataset.cccpSending = 'yes';
      send.disabled = true;
      send.textContent = 'Sending…';
      var timeout;
      var controller = new AbortController();
      try {
        timeout = window.setTimeout(function () { controller.abort(); }, 18000);
        var response = await fetch(secureEndpoint.value, {
          method: 'POST',
          mode: 'cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ lead: projectData(), turnstileToken: turnstileToken }),
          signal: controller.signal
        });
        var result = await response.json().catch(function () { return {}; });
        if (!response.ok || result.ok !== true || !result.inquiryId) {
          throw new Error(result.error || 'The service could not confirm your project. Please retry.');
        }
        showSuccess(result.inquiryId);
      } catch (error) {
        showError((error && error.message ? error.message : 'Connection failed.') + ' If needed, email contactus@cidercreekhardcider.com.');
        turnstileToken = '';
        if (window.turnstile && typeof window.turnstile.reset === 'function' && turnstileWidgetId !== null) {
          try { window.turnstile.reset(turnstileWidgetId); } catch (ignored) { /* no widget */ }
        }
        form.dataset.cccpSending = 'no';
        send.disabled = false;
        send.textContent = 'Send Project Inquiry ↗';
      } finally {
        if (timeout) window.clearTimeout(timeout);
      }
    });
    document.querySelectorAll('.cccp-service__link[data-cccp-service]').forEach(function (link) {
      link.addEventListener('click', function () {
        var target = Array.from(form.querySelectorAll('input[name="contact[Project type]"]')).find(function (x) { return x.value === link.dataset.cccpService; });
        if (target) target.checked = true;
        show(0, false);
      });
    });
    show(0, false);
  }
  function init(root) { (root || document).querySelectorAll('form.cccp-wizard').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

